module.exports = __webpack_public_path__ + "img/calendar.108fc387.svg";